import FilloutMriFormPage from "@/pages/FilloutMriFormPage.tsx";

export const privateRoutes = [
	{
		path: "/*",
		element: (
			<FilloutMriFormPage />
		),
	},
];
